// DEPRECATED DO NOT USE
// TODO: Remove this component and use https://react.lightningdesignsystem.com/components/icons/ instead
import React from 'react';
import PropTypes from 'prop-types';
import {rescueWithObject} from 'rescuer';

import actionSprite from '@devforce/tds-styles/dist/assets/icons/action-sprite/svg/symbols.svg';
import customSprite from '@devforce/tds-styles/dist/assets/icons/custom-sprite/svg/symbols.svg';
import doctypeSprite from '@devforce/tds-styles/dist/assets/icons/doctype-sprite/svg/symbols.svg';
import socialSprite from '@devforce/tds-styles/dist/assets/icons/social-sprite/svg/symbols.svg';
import standardSprite from '@devforce/tds-styles/dist/assets/icons/standard-sprite/svg/symbols.svg';
import utilitySprite from '@devforce/tds-styles/dist/assets/icons/utility-sprite/svg/symbols.svg';

// Keyed by the icon `type` prop (the first word of each sprite directory), the
// same mapping the previous require.context build produced.
const icons = rescueWithObject(() => ({
  action: actionSprite,
  custom: customSprite,
  doctype: doctypeSprite,
  social: socialSprite,
  standard: standardSprite,
  utility: utilitySprite,
}))();

export default class Icon extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    description: PropTypes.string,
    type: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
  };

  static defaultProps = {
    type: 'standard',
    className: 'slds-icon',
    containerClassName: 'slds-icon_container'
  };

  render() {
    const {
      props: {
        description,
        type,
        icon,
        className,
        containerClassName,
        style
      }
    } = this;

    return (
      <span
        className={containerClassName || `slds-icon_container slds-icon-${type}-${icon}`}
        title={description}>
        <svg
          className={className}
          aria-hidden="true"
          style={style}>
          <use xlinkHref={`${icons[type]}#${icon}`} />
        </svg>
        <span className="slds-assistive-text">{description}</span>
      </span>
    );
  }
}
